import React, { useState } from "react";
import { FaCheck } from "react-icons/fa";

const CustomCheckbox = ({ checked: initialChecked = false, onChange }) => {
  const [checked, setChecked] = useState(initialChecked);

  const toggleCheckbox = () => {
    const newCheckedState = !checked;
    setChecked(newCheckedState);
    if (onChange) {
      onChange(newCheckedState);
    }
  };

  return (
    <div
      onClick={toggleCheckbox}
      style={{
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        userSelect: "none",
        marginRight: "0.5rem",
      }}
    >
      <div
        style={{
          width: "20px",
          height: "20px",
          border: "2px solid #007bff",
          borderRadius: "4px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: checked ? "#007bff" : "#fff",
          transition: "background-color 0.3s",
        }}
      >
        {checked && <FaCheck color="white" size="12px" />}
      </div>
    </div>
  );
};

export default CustomCheckbox;
